import React from "react";
import { Dice5, Loader2, Play, X } from "lucide-react";

const BondDrawStageActions = ({
  hasPending = false,
  pendingExpired = false,
  canPlay = false,
  disabled = false,
  loading = false,
  onCancel,
  onPlay,
  onBuy,
}) => {
  if (hasPending) {
    const actionsLocked = disabled || loading || pendingExpired;
    return (
      <div className="bdraw-actions has-pending">
        <button
          type="button"
          className="bdraw-action bdraw-action-cancel"
          disabled={actionsLocked}
          onClick={onCancel}
        >
          <X size={15} strokeWidth={2.5} />
          <span>{loading ? "…" : "Cancel"}</span>
        </button>
        <button
          type="button"
          className="bdraw-action bdraw-action-play"
          disabled={actionsLocked}
          onClick={onPlay}
        >
          <Play size={15} strokeWidth={2.5} />
          <span>{loading ? "Drawing…" : "Draw now"}</span>
        </button>
      </div>
    );
  }

  if (!canPlay && !loading) {
    return null;
  }

  return (
    <div className="bdraw-actions">
      <button
        type="button"
        className="bdraw-action bdraw-action-buy"
        disabled={disabled || loading || !canPlay}
        onClick={onBuy}
      >
        {loading ? (
          <Loader2 size={15} className="bdraw-spin" strokeWidth={2.5} />
        ) : (
          <Dice5 size={15} strokeWidth={2.5} />
        )}
        <span>{loading ? "Reserving…" : "Reserve ticket"}</span>
      </button>
    </div>
  );
};

export default BondDrawStageActions;
